module.exports = __webpack_public_path__ + "static/TAH-ed128f2f9d92a57a1e90e6642f946c1e.png";